import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {LoginCallback} from '@okta/okta-react';
import {PageNotFound} from 'src/components/page-not-found';
import {useUserRoles} from 'src/hooks/useUserRoles';
import {AdminTabsPanelController} from 'src/modules/admin/admin-tabs-panel/admin-tabs-panel.controller';
import {AttributeController} from 'src/modules/attribute/attribute.controller';
import {EventController} from 'src/modules/event/event.controller';
import {EventCreationMode} from 'src/modules/event-create/constants';
import {EventCreateController} from 'src/modules/event-create/event-create.controller';
import {EventReviewController} from 'src/modules/event-review/event-review.controller';
import {TabsPanelController} from 'src/modules/tabs-panel/tabs-panel.controller';
import {UserSettingsController} from 'src/modules/user-settings/user-settings.controler';
import {Role} from 'src/openapi/models/Role';

export const AppRoutes = () => {
    const userRoles = useUserRoles();

    return (
        <Routes>
            <Route path="/login/callback" element={<LoginCallback/>}/>
            <Route path="/*" element={<TabsPanelController/>}/>
            <Route path="/events/:eventId" element={<EventController/>}/>
            <Route
                path="/attributes/:eventAttributeId/:attributeName"
                element={<AttributeController/>}
            />
            {userRoles.includes(Role.ROLE_UDEDT_ADMIN) &&
                <Route path="/admin/*" element={<AdminTabsPanelController/>}/>}
            <Route path="/user-settings" element={<UserSettingsController/>}/>
            <Route
                path="/events/create/:eventId/:changeRequestId"
                element={<EventCreateController mode={EventCreationMode.create}/>}
            />
            <Route
                path="/events/update/:eventId/:changeRequestId"
                element={<EventCreateController mode={EventCreationMode.update}/>}
            />
            <Route path="/events/review/:changeRequestId" element={<EventReviewController/>}/>
            <Route path="/404" element={<PageNotFound/>}/>
            <Route path="*" element={<Navigate to="/404"/>}/>
        </Routes>
    );
};
